<!--Description:地点为空显示组件-->
<!--Created by qgn on 2018/9/13-->
<template lang='pug'>
  .bg_empty
    div
      img(src='../../public/img/empty_body_bg.png')
      .arrow
        el-row
          el-col(:span='6')
            img(src='../../public/img/arrow.png') 
          el-col(:span='15')
            div {{empty_text || ''}}
</template>

<script>
export default {
  name: '',
  props: {
    empty_text: {
      type: String,
      defalut: '暂无数据'
    }
  }
}
</script>

<style scoped lang="scss">
.bg_empty {
  img {
    width: 90%;
  }
  height: 100%;
  min-height: 720px;
  color: #999;
  font-size: 20px;
  text-align: center;
  position: relative;
  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .arrow {
      img {
        width: 50%;
        min-width: 46px;
      }
    }
  }
}
</style>